<div class="normativa ion-padding">
  <div class="nm-nincs" *ngIf="!kezelheti">
    <ion-icon name="lock-closed-outline"></ion-icon>
    <strong>A normatíva-kalkulátor a könyvelő és az erre kijelölt adminisztrátor felülete.</strong>
  </div>

  <ng-container *ngIf="kezelheti">
    <div class="nm-fej">
      <label class="nm-ev">Év
        <select [(ngModel)]="ev" (ngModelChange)="frissit()">
          <option *ngFor="let e of evek" [ngValue]="e">{{ e }}</option>
        </select>
      </label>
      <ion-segment [value]="nezet" (ionChange)="nezet = $any($event).detail.value" class="nm-szegmens">
        <ion-segment-button value="szamitas"><ion-label>Számítás</ion-label></ion-segment-button>
        <ion-segment-button value="havi"><ion-label>Várt és beérkezett</ion-label></ion-segment-button>
        <ion-segment-button value="jogcimek"><ion-label>Jogcímek</ion-label></ion-segment-button>
      </ion-segment>
      <span class="nm-al" *ngIf="adat?.hatarozat">Határozat: {{ adat.hatarozat }}</span>
    </div>

    <div class="nm-hiba" *ngIf="hiba">{{ hiba }}</div>
    <div class="nm-uzenet" *ngIf="uzenet">{{ uzenet }}</div>
    <ion-progress-bar type="indeterminate" *ngIf="betolt"></ion-progress-bar>

    <ng-container *ngIf="adat">
      <!-- Üres év: másolás az előző évből vagy kiinduló jogcímek -->
      <div class="nm-kartya" *ngIf="!adat.jogcimek.length">
        <div class="nm-cim">{{ ev }}-re még nincsenek jogcímek.</div>
        <p class="nm-al">A fajlagos összegeket és az arányszámokat a tárgyévi központi költségvetési törvény 7. melléklete adja – évente változnak.</p>
        <div class="nm-sor">
          <label>Átmásolás ebből az évből:
            <select [(ngModel)]="masolasForras"><option *ngFor="let e of evek" [ngValue]="e">{{ e }}</option></select>
          </label>
          <ion-button size="small" (click)="evMasol()">Jogcímek átmásolása</ion-button>
          <ion-button size="small" fill="outline" (click)="sablon()">Kiinduló jogcímek (általános iskola, 2026-os összegek)</ion-button>
        </div>
      </div>

      <!-- ═══ ÖSSZESÍTÉS (mindhárom nézet fölött) ═══ -->
      <div class="nm-osszeg" *ngIf="adat.jogcimek.length">
        <div><span>Várható I–VIII. hó</span><b>{{ ft(adat.osszesen.mind.o18) }} Ft</b>
          <small>{{ adat.idoszakok.i18.nap }} létszámából{{ adat.idoszakok.i18.becsult ? ' (becsült)' : '' }} · havi {{ ft(adat.osszesen.mind.o18 / 8) }} Ft</small></div>
        <div><span>Várható IX–XII. hó</span><b>{{ ft(adat.osszesen.mind.o912) }} Ft</b>
          <small>{{ adat.idoszakok.i912.nap }} létszámából<ng-container *ngIf="adat.idoszakok.i912.becsult"> – <b class="nm-becsult">becsült</b>, október 1-jéig a mai aktív létszám</ng-container> · havi {{ ft(adat.osszesen.mind.o912 / 4) }} Ft</small></div>
        <div><span>Várható {{ ev }}. év összesen</span><b>{{ ft(adat.osszesen.mind.ev) }} Ft</b>
          <small>Kv.tv.: {{ ft(adat.osszesen.kvtv.ev) }} · kiegészítő: {{ ft(adat.osszesen.kiegeszito.ev) }}</small></div>
        <div *ngIf="adat.hatarozat_osszesen"><span>A határozat szerint</span><b>{{ ft(adat.hatarozat_osszesen.mind.ev) }} Ft</b>
          <small>{{ ft(adat.hatarozat_osszesen.mind.o18) }} + {{ ft(adat.hatarozat_osszesen.mind.o912) }} ·
            eltérés: <span [class.piros]="elteres(adat.osszesen.mind.ev, adat.hatarozat_osszesen.mind.ev) < 0">{{ ft(elteres(adat.osszesen.mind.ev, adat.hatarozat_osszesen.mind.ev)) }} Ft</span></small></div>
        <div *ngIf="adat.beerkezett?.aktiv"><span>Beérkezett eddig</span><b>{{ ft(beerkezettOssz) }} Ft</b>
          <small>a mai napig várt: {{ ft(vartEddig) }} Ft</small></div>
      </div>
      <div class="nm-ellenorzes" *ngIf="adat.ellenorzes" [class.hibas]="adat.ellenorzes.egyezik_db !== adat.ellenorzes.jogcim_db">
        <ion-icon [name]="adat.ellenorzes.egyezik_db === adat.ellenorzes.jogcim_db ? 'checkmark-circle' : 'alert-circle'"></ion-icon>
        Képlet-ellenőrzés: a határozat létszámaival számolva {{ adat.ellenorzes.egyezik_db }} / {{ adat.ellenorzes.jogcim_db }} jogcímen
        forintra a határozat összege jön ki.
      </div>

      <!-- ═══ SZÁMÍTÁS ═══ -->
      <ng-container *ngIf="nezet === 'szamitas' && adat.jogcimek.length">
        <div class="nm-gorgo">
          <table class="nm-tabla">
            <tr>
              <th>Jogcím</th><th class="sz">Fajlagos<br><small>Ft/létszám/év</small></th>
              <th class="sz">Létszám I–VIII.</th><th class="sz">Létszám IX–XII.</th>
              <th class="sz">Számított<br><small>I–VIII. / IX–XII.</small></th>
              <th class="sz">I–VIII. hó<br><small>8 hónap</small></th><th class="sz">IX–XII. hó<br><small>4 hónap</small></th><th class="sz">Év</th>
              <th class="sz" *ngIf="adat.hatarozat_osszesen">Határozat<br><small>I–VIII. / IX–XII.</small></th>
            </tr>
            <ng-container *ngFor="let j of aktivJogcimek">
              <tr [class.kieg]="j.csoport === 'kiegeszito'">
                <td>
                  <div class="nm-jnev">{{ j.nev }}</div>
                  <div class="nm-al">{{ j.kod }} · {{ modszerNev(j.modszer) }}<ng-container *ngIf="j.oszto"> · arányszám {{ sz(j.oszto, 3) }}</ng-container>
                    <ng-container *ngIf="j.modszer === 'etkezes'"> · F = {{ sz(j.f_tenyezo) }}</ng-container></div>
                </td>
                <td class="sz">{{ ft(j.fajlagos) }}</td>
                <!-- Létszám: pedagógus-jogcímnél időszakonként, egyébként egész évre -->
                <ng-container *ngFor="let ido of (j.modszer === 'pedagogus' ? ['1-8', '9-12'] : ['ev'])">
                  <td class="sz" [attr.colspan]="j.modszer === 'pedagogus' ? 1 : 2">
                    <ng-container *ngIf="(ido === '9-12' ? j.letszam.i912 : j.letszam.i18) as l">
                      <b>{{ sz(l.letszam) }}</b>
                      <ion-badge color="warning" *ngIf="l.felulirt" [title]="'Számolt: ' + sz(l.szamolt) + (l.felulir_megj ? ' – ' + l.felulir_megj : '')">kézzel</ion-badge>
                      <ion-badge color="medium" *ngIf="l.becsult && !l.felulirt">becsült</ion-badge>
                      <div class="nm-al">{{ l.nap }}</div>
                      <div class="nm-al">{{ l.leiras }}</div>
                      <div class="nm-al" *ngIf="l.felulirt">számolt: {{ sz(l.szamolt) }}<ng-container *ngIf="l.felulir_megj"> · {{ l.felulir_megj }}</ng-container></div>
                      <ng-container *ngIf="j.forras !== 'jogcim'">
                        <ion-button fill="clear" size="small" *ngIf="felulirNyitva !== felulirKulcs(j, ido)" (click)="felulirNyit(j, ido, l.letszam)">
                          <ion-icon name="create-outline"></ion-icon></ion-button>
                        <div class="nm-felulir" *ngIf="felulirNyitva === felulirKulcs(j, ido)">
                          <input type="number" step="0.1" [(ngModel)]="felulirErtek">
                          <input type="text" [(ngModel)]="felulirMegj" placeholder="Indoklás (pl. KIR-statisztika)">
                          <ion-button size="small" (click)="felulirMent(j, ido)">Felülír</ion-button>
                          <ion-button size="small" fill="outline" *ngIf="l.felulirt" (click)="felulirMent(j, ido, true)">Számolt vissza</ion-button>
                          <ion-button size="small" fill="clear" (click)="felulirNyitva = null">Mégse</ion-button>
                        </div>
                      </ng-container>
                    </ng-container>
                  </td>
                </ng-container>
                <td class="sz">{{ sz(j.sz18) }}<ng-container *ngIf="j.modszer === 'pedagogus'"> / {{ sz(j.sz912) }}</ng-container></td>
                <td class="sz">{{ ft(j.o18) }}</td>
                <td class="sz">{{ ft(j.o912) }}</td>
                <td class="sz"><b>{{ ft(j.ev) }}</b></td>
                <td class="sz" *ngIf="adat.hatarozat_osszesen">
                  <ng-container *ngIf="j.hatarozat">
                    {{ ft(j.hatarozat.osszeg_1_8) }} / {{ ft(j.hatarozat.osszeg_9_12) }}
                    <div class="nm-al">létszám: {{ sz(j.hatarozat.letszam_1_8) }}<ng-container *ngIf="j.modszer === 'pedagogus'"> / {{ sz(j.hatarozat.letszam_9_12) }}</ng-container></div>
                    <div class="nm-al" *ngIf="j.hatarozat.ellenorzes" [class.zold]="j.hatarozat.ellenorzes.egyezik" [class.piros]="!j.hatarozat.ellenorzes.egyezik">
                      {{ j.hatarozat.ellenorzes.egyezik ? '✓ a képlet visszaadja' : 'képlet: ' + ft(j.hatarozat.ellenorzes.o18) + ' / ' + ft(j.hatarozat.ellenorzes.o912) }}</div>
                  </ng-container>
                </td>
              </tr>
            </ng-container>
            <tr class="nm-ossz">
              <td colspan="5">Kv.tv. szerinti támogatások</td>
              <td class="sz">{{ ft(adat.osszesen.kvtv.o18) }}</td><td class="sz">{{ ft(adat.osszesen.kvtv.o912) }}</td><td class="sz">{{ ft(adat.osszesen.kvtv.ev) }}</td>
              <td class="sz" *ngIf="adat.hatarozat_osszesen">{{ ft(adat.hatarozat_osszesen.kvtv.o18) }} / {{ ft(adat.hatarozat_osszesen.kvtv.o912) }}</td>
            </tr>
            <tr class="nm-ossz">
              <td colspan="5">Béremelési kiegészítő (kötött felhasználású)</td>
              <td class="sz">{{ ft(adat.osszesen.kiegeszito.o18) }}</td><td class="sz">{{ ft(adat.osszesen.kiegeszito.o912) }}</td><td class="sz">{{ ft(adat.osszesen.kiegeszito.ev) }}</td>
              <td class="sz" *ngIf="adat.hatarozat_osszesen">{{ ft(adat.hatarozat_osszesen.kiegeszito.o18) }} / {{ ft(adat.hatarozat_osszesen.kiegeszito.o912) }}</td>
            </tr>
            <tr class="nm-ossz nm-vegosszeg">
              <td colspan="5">Támogatások összesen</td>
              <td class="sz">{{ ft(adat.osszesen.mind.o18) }}</td><td class="sz">{{ ft(adat.osszesen.mind.o912) }}</td><td class="sz">{{ ft(adat.osszesen.mind.ev) }}</td>
              <td class="sz" *ngIf="adat.hatarozat_osszesen">{{ ft(adat.hatarozat_osszesen.mind.o18) }} / {{ ft(adat.hatarozat_osszesen.mind.o912) }}</td>
            </tr>
          </table>
        </div>
        <p class="nm-al nm-lab">
          A létszám mindenhol az aktív jogviszony (szünetelő jogviszony és vendégtanuló nélkül; munkatársnál megbízás és vállalkozó nélkül, teljes munkaidőre
          átszámítva). Az I–VIII. hónap a {{ ev - 1 }}. október 1-jei, a IX–XII. a {{ ev }}. október 1-jei létszámból számol.
          <ng-container *ngIf="adat.pedagogusok?.length"> Tájékoztató – aktív pedagógus munkakörű munkatársak:
            <ng-container *ngFor="let p of adat.pedagogusok; let u = last">{{ p.nap }}: {{ p.fo }} fő ({{ sz(p.fte) }} teljes munkaidős){{ u ? '.' : '; ' }}</ng-container>
          </ng-container>
        </p>
      </ng-container>

      <!-- ═══ VÁRT ÉS BEÉRKEZETT ═══ -->
      <ng-container *ngIf="nezet === 'havi' && adat.jogcimek.length">
        <div class="nm-nincs" *ngIf="!adat.beerkezett?.aktiv">
          <ion-icon name="link-outline"></ion-icon>
          <span>A beérkezett összegekhez a NAPLO-ban a fenntartó ügyfelénél ki kell jelölni a SULINFORM-intézményt és a bankszámlát (ugyanaz, mint a Támogatás fülnél).</span>
        </div>
        <div class="nm-gorgo">
          <table class="nm-tabla">
            <tr>
              <th>Hónap</th><th class="sz">Várt (a képlet szerint)</th><th class="sz" *ngIf="adat.hatarozat_osszesen">A határozat szerint</th>
              <th class="sz">Beérkezett</th><th class="sz" *ngIf="vanJavasolt">Ebből még nincs besorolva</th>
              <th class="sz">Várt halmozott</th><th class="sz">Beérkezett halmozott</th><th class="sz">Eltérés</th>
            </tr>
            <tr *ngFor="let h of adat.honapok" [class.jovo]="!h.mult">
              <td>{{ HONAPOK[h.honap - 1] }}</td>
              <td class="sz">{{ ft(h.vart) }}</td>
              <td class="sz" *ngIf="adat.hatarozat_osszesen">{{ ft(h.hatarozat) }}</td>
              <td class="sz">{{ ft(h.beerkezett + h.javasolt) }}</td>
              <td class="sz" *ngIf="vanJavasolt">{{ h.javasolt ? ft(h.javasolt) : '' }}</td>
              <td class="sz">{{ ft(h.kum_vart) }}</td>
              <td class="sz">{{ ft(h.kum_beerkezett) }}</td>
              <td class="sz" [class.piros]="h.mult && h.kum_beerkezett - h.kum_vart < 0">{{ h.mult ? ft(h.kum_beerkezett - h.kum_vart) : '' }}</td>
            </tr>
          </table>
        </div>
        <p class="nm-al nm-lab">
          A Kincstár havonta, a tárgyhó 7-éig utal: január–augusztusban az I–VIII. időszak összegének 1/8-át, szeptember–decemberben a IX–XII.
          időszakénak 1/4-ét. Január–áprilisban előleg érkezik, a különbözetet a május rendezi – ezért a halmozott oszlopok a beszédesek.
          <ng-container *ngIf="adat.beerkezett?.aktiv">A beérkezett összeg a {{ adat.beerkezett.ugyfel_nev }} ({{ adat.beerkezett.iban }}) számlájára
            érkezett, a Támogatás → Bankpartnerek nézetben „Normatíva” kategóriába sorolt jóváírások.</ng-container>
          <ng-container *ngIf="vanJavasolt"> A „még nincs besorolva” tételek a küldő vagy a közlemény alapján normatívának látszanak
            (pl. „köznevelési célú támogatás”) – a Támogatás → Bankpartnerek nézetben sorold be őket.</ng-container>
        </p>
        <table class="nm-tabla" *ngIf="adat.beerkezett?.tetelek?.length">
          <tr><th>Dátum</th><th>Küldő</th><th>Közlemény</th><th class="sz">Összeg</th><th></th></tr>
          <tr *ngFor="let t of adat.beerkezett.tetelek">
            <td>{{ t.datum }}</td><td>{{ t.partner_nev }}</td><td class="nm-al">{{ t.kozlemeny }}</td><td class="sz">{{ ft(t.osszeg) }} Ft</td>
            <td><ion-badge *ngIf="t.allapot === 'javasolt'" color="medium">nincs besorolva</ion-badge></td>
          </tr>
        </table>
      </ng-container>

      <!-- ═══ JOGCÍMEK SZERKESZTÉSE ═══ -->
      <ng-container *ngIf="nezet === 'jogcimek'">
        <div class="nm-sor">
          <label>A határozat ({{ ev }}):
            <input type="text" #hat [value]="adat.hatarozat || ''" placeholder="iktatószám, kelte" style="min-width: 320px">
          </label>
          <ion-button size="small" fill="outline" (click)="hatarozatMent(hat.value)">Mentés</ion-button>
          <span class="nm-tagolo"></span>
          <ion-button size="small" (click)="ujJogcim()"><ion-icon name="add" slot="start"></ion-icon>Új jogcím</ion-button>
        </div>
        <table class="nm-tabla" *ngIf="adat.jogcimek.length">
          <tr><th>#</th><th>Jogcím</th><th>Számítás</th><th>Létszám forrása</th><th class="sz">Fajlagos</th><th></th></tr>
          <tr *ngFor="let j of adat.jogcimek" [class.inaktiv]="!j.aktiv">
            <td>{{ j.sorrend }}</td>
            <td><div class="nm-jnev">{{ j.nev }}</div><div class="nm-al">{{ j.kod }} · {{ adat.csoportok?.[j.csoport] }}{{ j.aktiv ? '' : ' · kikapcsolva' }}</div></td>
            <td>{{ modszerNev(j.modszer) }}<div class="nm-al" *ngIf="j.oszto">arányszám: {{ sz(j.oszto, 3) }}</div>
              <div class="nm-al" *ngIf="j.f_tenyezo">F = {{ sz(j.f_tenyezo) }}</div></td>
            <td>{{ forrasNev(j.forras) }}
              <div class="nm-al" *ngIf="j.forras === 'tanulo'">{{ j.evfolyam_tol ?? '–' }}–{{ j.evfolyam_ig ?? '–' }}. évfolyam · SNI ×{{ sz(j.sni_szorzo) }}</div>
              <div class="nm-al" *ngIf="j.forras === 'munkatars'">munkakör: {{ j.munkakor_szuro || 'mind' }}</div>
              <div class="nm-al" *ngIf="j.forras === 'jogcim'">{{ alapNev(j.alap_jogcim) }}</div></td>
            <td class="sz">{{ ft(j.fajlagos) }}</td>
            <td class="sz">
              <ion-button fill="clear" size="small" (click)="jogcimSzerk(j)"><ion-icon name="create-outline"></ion-icon></ion-button>
              <ion-button fill="clear" size="small" color="danger" (click)="jogcimTorol(j)"><ion-icon name="trash-outline"></ion-icon></ion-button>
            </td>
          </tr>
        </table>

        <div class="nm-kartya" *ngIf="szerk">
          <div class="nm-cim">{{ szerk.id ? 'Jogcím szerkesztése' : 'Új jogcím' }} ({{ ev }})</div>
          <div class="nm-urlap">
            <label class="szeles">Megnevezés<input type="text" [(ngModel)]="szerk.nev"></label>
            <label>Kv.tv. 7. melléklet jogcíme<input type="text" [(ngModel)]="szerk.kod" placeholder="7/1.1.2"></label>
            <label>Csoport
              <select [(ngModel)]="szerk.csoport"><option *ngFor="let c of adat.csoportok | keyvalue" [value]="c.key">{{ c.value }}</option></select></label>
            <label>Számítás módja
              <select [(ngModel)]="szerk.modszer"><option *ngFor="let m of adat.modszerek | keyvalue" [value]="m.key">{{ m.value }}</option></select></label>
            <label>Fajlagos összeg (Ft/számított létszám/év)<input type="number" [(ngModel)]="szerk.fajlagos"></label>
            <label *ngIf="szerk.modszer === 'pedagogus'">Arányszám (osztó)<input type="number" step="0.1" [(ngModel)]="szerk.oszto"></label>
            <label *ngIf="szerk.modszer === 'etkezes'">F tényező (feladatellátási helyek: 1 → 1,0; 2–3 → 1,1; 4–6 → 1,2; több → 1,3)
              <input type="number" step="0.1" [(ngModel)]="szerk.f_tenyezo"></label>
            <label>Létszám forrása
              <select [(ngModel)]="szerk.forras"><option *ngFor="let f of adat.forrasok | keyvalue" [value]="f.key">{{ f.value }}</option></select></label>
            <ng-container *ngIf="szerk.forras === 'tanulo'">
              <label>Évfolyamtól<input type="number" [(ngModel)]="szerk.evfolyam_tol"></label>
              <label>Évfolyamig<input type="number" [(ngModel)]="szerk.evfolyam_ig"></label>
              <label>SNI-tanuló hány főnek számít<input type="number" step="1" [(ngModel)]="szerk.sni_szorzo"></label>
            </ng-container>
            <label *ngIf="szerk.forras === 'munkatars'" class="szeles">Munkakör (vesszővel elválasztott részletek, pl. „asszisztens, iskolatitkár”)
              <input type="text" [(ngModel)]="szerk.munkakor_szuro"></label>
            <label *ngIf="szerk.forras === 'jogcim'" class="szeles">Melyik jogcím létszámát használja
              <select [(ngModel)]="szerk.alap_jogcim"><option *ngFor="let a of alapJeloltek" [value]="a.id">{{ a.nev }}</option></select></label>
            <label>Sorrend<input type="number" [(ngModel)]="szerk.sorrend"></label>
            <label class="pipa"><input type="checkbox" [(ngModel)]="szerk.aktiv"> számít az összesítésbe</label>
          </div>
          <div class="nm-cim kicsi">A határozat számai (összevetéshez és a képlet ellenőrzéséhez – elhagyható)</div>
          <div class="nm-urlap">
            <label>Létszám I–VIII.<input type="number" step="0.1" [(ngModel)]="szerk.hat_letszam_1_8"></label>
            <label>Létszám IX–XII.<input type="number" step="0.1" [(ngModel)]="szerk.hat_letszam_9_12"></label>
            <label>Összeg I–VIII. (Ft)<input type="number" [(ngModel)]="szerk.hat_osszeg_1_8"></label>
            <label>Összeg IX–XII. (Ft)<input type="number" [(ngModel)]="szerk.hat_osszeg_9_12"></label>
            <label class="szeles">Megjegyzés<input type="text" [(ngModel)]="szerk.megjegyzes"></label>
          </div>
          <div class="nm-sor">
            <ion-button size="small" (click)="jogcimMent()">Mentés</ion-button>
            <ion-button size="small" fill="clear" (click)="szerk = null">Mégse</ion-button>
          </div>
        </div>

        <div class="nm-sor" *ngIf="adat.jogcimek.length">
          <span class="nm-al">Új év előkészítése: válts a következő évre, és másold át ezeket a jogcímeket – utána a fajlagos összegeket a tárgyévi Kv.tv. szerint írd át.</span>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
</div>
